export default __webpack_public_path__ + "static/media/Halebidu.40e7f384.jpg";